import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { WSMutationConfig } from "@ws-react-query";
import { queriesAcknowledgements, queriesNotifications } from "@query";
import { useWSMutation } from "../../../../query/helpers";
import { acknowledgementVersions } from "../../../../shared/constants/acknowledgements";
import { WSServiceError } from "../../../../utils/serviceHelper";

export const useMutationSubmit = (config?: WSMutationConfig<void>) => {
  const [acceptAcknowledgement] =
    queriesAcknowledgements.acceptAcknowledgement.useMutation();

  return useWSMutation<any, WSServiceError>(
    async () => {
      await acceptAcknowledgement(
        {
          acknowledgementName: AcknowledgementName.W9_CERTIFICATION,
          acceptAcknowledgementRequest: {
            version:
              acknowledgementVersions[AcknowledgementName.W9_CERTIFICATION]
          }
        },
        { throwOnError: true }
      );
    },
    {
      dependencies: [queriesNotifications.listNotifications.queryKeyBase],
      ...config
    }
  );
};
